import React from "react";

function ChallengeItem({ item, isSelected, onClick }) {
  const isVideo = item.type === "video";
  const isQuiz = item.type === "quiz";
  const isCompleted = item.status === "Completed";
  const isInProgress = item.status === "In Progress";
  const isLocked = !item.unlocked;

  const getStatusIcon = () => {
    if (isLocked) {
      return (
        <svg className="w-4 h-4 text-zinc-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      );
    }
    if (isCompleted) {
      return (
        <svg className="w-4 h-4 text-emerald-400 flex-shrink-0 ml-auto" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
      );
    }
    return null;
  };

  const getTypeIcon = () => {
    if (isVideo) {
      return (
        <svg className="w-4 h-4 text-blue-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
        </svg>
      );
    }
    if (isQuiz) {
      return (
        <svg
          className={`w-4 h-4 flex-shrink-0 ${isCompleted ? "text-emerald-400" : isInProgress ? "text-amber-400" : "text-purple-400"}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      );
    }
    return (
      <svg
        className={`w-4 h-4 flex-shrink-0 ${isCompleted ? "text-emerald-400" : isInProgress ? "text-amber-400" : "text-zinc-500"}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
      </svg>
    );
  };

  return (
    <button
      onClick={() => !isLocked && onClick(item)}
      disabled={isLocked}
      className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left transition-colors ${
        isLocked
          ? "opacity-50 cursor-not-allowed"
          : isSelected
          ? "bg-amber-500/10 border border-amber-500/30"
          : "hover:bg-zinc-800/50 border border-transparent"
      }`}
    >
      {getTypeIcon()}
      <span
        className={`font-display text-sm truncate flex-1 ${
          isLocked ? "text-zinc-600" : isSelected ? "text-amber-400" : "text-zinc-400"
        }`}
      >
        {item.title}
      </span>
      {getStatusIcon()}
    </button>
  );
}

export default ChallengeItem;
